/** User-supplied navigation categories (27 October 2026), not title/ownership advice. */
export type EstateCategory = "secure-estate" | "secure-sectional-title";

export const ESTATE_CATEGORY_LABELS: Readonly<Record<EstateCategory, string>> = Object.freeze({
  "secure-estate": "Secure Estates",
  "secure-sectional-title": "Secure Sectional Title",
});

export const ESTATE_CATEGORY_BY_SLUG: Readonly<Record<string, EstateCategory>> = Object.freeze({
  "palm-lakes": "secure-estate",
  springvale: "secure-estate",
  lalela: "secure-estate",
  seaton: "secure-estate",
  zululami: "secure-estate",
  elaleni: "secure-estate",
  brettenwood: "secure-estate",
  dunkirk: "secure-estate",
  fable: "secure-estate",
  tahari: "secure-estate",
  simbithi: "secure-estate",
  tanglewood: "secure-estate",
  "beverley-hills": "secure-estate",
  seaward: "secure-estate",
  "port-zimbali": "secure-estate",
  zimbali: "secure-estate",
  hilltop: "secure-estate",
  lazuli: "secure-estate",
  "zimbali-lakes": "secure-estate",
  "umhlali-golf": "secure-estate",
  brooklyn: "secure-estate",
  caledon: "secure-estate",
  helmsley: "secure-estate",
  fairview: "secure-estate",
  "sheffield-manor": "secure-sectional-title",
  santorini: "secure-sectional-title",
  wakenshaw: "secure-sectional-title",
  "the-greens": "secure-sectional-title",
  "ballito-gardens": "secure-sectional-title",
  shortens: "secure-sectional-title",
  woodlands: "secure-sectional-title",
  "manor-estates": "secure-sectional-title",
});

const aliases: Readonly<Record<string, string>> = Object.freeze({
  "beverly-hills": "beverley-hills",
  "seaward-estate": "seaward",
  "umhlali-golf-estate": "umhlali-golf",
});

export function parseEstateCategory(value: unknown): EstateCategory | null {
  return value === "secure-estate" || value === "secure-sectional-title" ? value : null;
}

export function getEstateCategory(slug: string, explicitCategory?: unknown): EstateCategory | null {
  const explicit = parseEstateCategory(explicitCategory);
  if (explicit) return explicit;
  const normalized = slug.trim().toLowerCase().replace(/\s+/g, "-");
  const canonical = Object.hasOwn(aliases, normalized) ? aliases[normalized]! : normalized;
  return Object.hasOwn(ESTATE_CATEGORY_BY_SLUG, canonical) ? ESTATE_CATEGORY_BY_SLUG[canonical]! : null;
}

export function matchesEstateCategory(slug: string, category: EstateCategory | null, explicitCategory?: unknown): boolean {
  return category === null || getEstateCategory(slug, explicitCategory) === category;
}
